<template>
  <el-dialog
    class="task-dialog"
    :title="$t('执行任务')"
    width="30%"
    :visible.sync="visible"
    :before-close="closeExecuteDialogHandler"
    :append-to-body="fullScreenFlag"
  >
    <el-form ref="taskForm" :rules="taskRules" :model="taskForm" label-width="180px">
      <el-form-item :label="$t('选择设备')" prop="sn">
        <el-select popper-class="task-options" v-model="taskForm.sn">
          <el-option
            v-for="(item, index) in deviceList"
            :label="item.name"
            :value="item.sn"
            :key="index"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('执行开始时间')" prop="flightStartTime">
        <el-date-picker
          popper-class="task-date-picker"
          v-model="taskForm.flightStartTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>

      <el-form-item :label="$t('执行结束时间')" prop="flightEndTime">
        <el-date-picker
          popper-class="task-date-picker"
          v-model="taskForm.flightEndTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
        ></el-date-picker>
      </el-form-item>

      <el-form-item :label="$t('备注')">
        <el-input type="textarea" v-model="taskForm.remarks" autosize></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeExecuteDialogHandler">{{ $t('取消') }}</el-button>
      <el-button v-if="taskId" type="primary" @click="saveTaskExecuteHandler">
        {{ $t('确定') }}
      </el-button>
      <el-button v-else type="primary" @click="updateTaskExecuteHandler">
        {{ $t('确定') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';

import { saveFlightRecordServer, updateFlightRecordServer } from '@/api/flight-task';

export default {
  computed: {
    ...mapState('app', ['fullScreenFlag'])
  },
  props: {
    taskId: String,
    taskInfo: {
      type: Object,
      default: () => {}
    },
    deviceList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    taskInfo: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.taskForm = val;
        }
      }
    }
  },
  data() {
    return {
      visible: false,
      taskForm: {
        sn: '',
        flightStartTime: '',
        flightEndTime: '',
        remarks: ''
      },
      taskRules: {
        sn: [{ required: true, message: '请选择设备', trigger: 'blur' }],
        flightStartTime: [
          { type: 'string', required: true, message: '请选择日期', trigger: 'change' }
        ],
        flightEndTime: [
          { type: 'string', required: true, message: '请选择日期', trigger: 'change' }
        ]
      }
    };
  },
  methods: {
    closeExecuteDialogHandler() {
      this.$emit('closeTask');
      this.taskForm.remarks = '';
      this.$refs.taskForm.resetFields();
      this.visible = false;
    },
    saveTaskExecuteHandler() {
      this.$refs.taskForm.validate(valid => {
        if (valid) {
          let timeFlag = this.verificationTime([
            this.taskForm.flightStartTime,
            this.taskForm.flightEndTime
          ]);

          if (timeFlag) {
            this.$message.warning('时间范围不能大于一小时');
            return;
          }

          this.taskForm.flightMissionId = this.taskId;
          saveFlightRecordServer(this.taskForm).then(res => {
            if (res.code == 200) {
              this.$message.success(this.$t('保存成功'));
              this.closeExecuteDialogHandler();
            }
          });
        }
      });
    },
    updateTaskExecuteHandler() {
      this.$refs.taskForm.validate(valid => {
        if (valid) {
          let timeFlag = this.verificationTime([
            this.taskForm.flightStartTime,
            this.taskForm.flightEndTime
          ]);

          if (timeFlag) {
            this.$message.warning('时间范围不能大于一小时');
            return;
          }

          updateFlightRecordServer(this.taskForm).then(res => {
            if (res.code == 200) {
              this.$message.success('更新成功');
              this.closeExecuteDialogHandler();
              this.$emit('refreshTaskList', this.taskForm.flightMissionId);
            }
          });
        }
      });
    },
    verificationTime(time) {
      let startTime = new Date(time[0]).getTime();
      let endTime = new Date(time[1]).getTime();

      return endTime - startTime > 3600000;
    }
  },
  components: {}
};
</script>

<style lang="scss">
.task-dialog .el-dialog {
  background-color: var(--drone-dialog-date-picker-bg-color) !important;
  .el-input__inner,
  .el-textarea__inner {
    background-color: var(--drone-dialog-date-picker-bg-color) !important;
  }
}

.task-options {
  background-color: var(--drone-dialog-date-picker-bg-color) !important;
  .el-scrollbar {
    .el-select-dropdown__wrap {
      .el-scrollbar__view {
        .el-select-dropdown__item.hover,
        .el-select-dropdown__item:hover {
          background-color: var(--drone-select-hover-bg-color);
        }
      }
    }
  }
}
.task-date-picker div {
  background-color: var(--drone-dialog-date-picker-bg-color) !important;

  .el-input__inner {
    background-color: var(--drone-dialog-date-picker-bg-color) !important;
  }
}
.task-date-picker .el-picker-panel__footer .el-button:last-child {
  color: #0c1620;
  background-color: #49c7c3;
  border-color: #49c7c3;
}
</style>
